import { render, staticRenderFns } from "./ProductComment.vue?vue&type=template&id=c65fb49a&"
import script from "./ProductComment.vue?vue&type=script&lang=js&"
export * from "./ProductComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports